// LogoSmall.jsx

import React, { useCallback } from 'react';

// Context
import { useNavigation } from 'context/NavigationContext';
import { useTheme } from 'context/ThemeContext';

// Device Detection

// Routing
import { useNavigate } from 'react-router-dom';

// Utilities
import { SectionType } from 'utilities/Enums';

// CSS
import './LogoSmall.css';

// Icons
import logoname from 'images/orbital_logo.png';

/**
 * LogoSmall
 * 
 * Renders a small version of the logo.
 * 
 * @returns {ReactNode} LogoSmall.
 */
const LogoSmall = ({ width = '120px' }) => {

  // ----- CONTEXT ----- //

  // Global Context
  const { setCurrentSection } = useNavigation();

  // Theme Context
  const { theme } = useTheme();

  // Routing
  const navigate = useNavigate();

  // Device Detection (currently unused)

  // ----- HANDLERS ----- //

  const handleClick = useCallback(() => {
    setCurrentSection(SectionType.HOME);
    navigate('/');
  }, [setCurrentSection, navigate]);

  return (

    <div className="logo-small-container"
      onClick={handleClick}>
        
      {/* LOGO IMAGE */}
      <img
        className="logo-small-image"
        style={{
          width: width,
        }}
        src={logoname}
        alt="Orbital"
      />
      
      {/* LOGO TEXT 
        <div className="logo-small-text"
          style={{
            color: theme.foreground
          }}>orbital</div>

        <div className="logo-small-trademark"
          style={{
            color: theme.foregroundMuted
          }}>TM</div>
          */}


    </div>

  );
};

export default LogoSmall;

